/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_DuplicatedInputs */

const vi_einvoice_publish_duplicated = /** @type {(inputs: Einvoice_Publish_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA báo hóa đơn bị trùng nên ERP chưa nhận được số hóa đơn.`)
};

/**

* @param {Einvoice_Publish_DuplicatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_duplicated = /** @type {((inputs?: Einvoice_Publish_DuplicatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_DuplicatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_duplicated(inputs)
});